import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { BuildingTypeSelectFormikField } from '../../../BuildingTypeSelectFormikField'
import { BUILDING_FORM_FIELD_NAME_TYPE_OF_BUILDING } from '../../BuildingForm.constants'

import { BUILDING_FORM_BUILDING_TYPE_API_PARAMS } from './BuildingTypeField.constants'

function BuildingTypeField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingTypeSelectFormikField
      apiParams={BUILDING_FORM_BUILDING_TYPE_API_PARAMS}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Building.LivingTypePlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Building.LivingTypeLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={BUILDING_FORM_FIELD_NAME_TYPE_OF_BUILDING}
    />
  )
}

export default BuildingTypeField
